import { type AnyAbility, type RawRuleOf } from "@casl/ability";
import { createPrismaAbility, type PrismaQuery } from "@casl/prisma";
import { createContextualCan } from "@casl/react";
import { createContext } from "react";

export type TaskAbility = AnyAbility;

export type TaskAbilityRule = RawRuleOf<TaskAbility>;

export const createTaskAbility = (rules: TaskAbilityRule[] = []) =>
    createPrismaAbility<[string, string], PrismaQuery>(rules);

export const TaskAbilityContext = createContext<TaskAbility>(createTaskAbility());

export const Can = createContextualCan(TaskAbilityContext.Consumer);
